"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerGender = void 0;
var ProducerGender;
(function (ProducerGender) {
    ProducerGender["Male"] = "Male";
    ProducerGender["Female"] = "Female";
})(ProducerGender = exports.ProducerGender || (exports.ProducerGender = {}));
//# sourceMappingURL=producer-gender.js.map